import { render, staticRenderFns } from "./LiveChatDummySlot.vue?vue&type=template&id=655fdbc2&"
import script from "./LiveChatDummySlot.vue?vue&type=script&lang=js&"
export * from "./LiveChatDummySlot.vue?vue&type=script&lang=js&"
import style0 from "./LiveChatDummySlot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('655fdbc2')) {
      api.createRecord('655fdbc2', component.options)
    } else {
      api.reload('655fdbc2', component.options)
    }
    module.hot.accept("./LiveChatDummySlot.vue?vue&type=template&id=655fdbc2&", function () {
      api.rerender('655fdbc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LiveChatDummySlot.vue"
export default component.exports